var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_Inputs"
  }, /*#__PURE__*/React.createElement("path", {
    id: "email",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3025 12L27.3754 25.6584C27.7406 25.9505 28.2596 25.9505 28.6248 25.6584L45.6978 12H10.3025ZM55.9877 10.2731C56.0559 9.52793 55.8471 8.75638 55.3427 8.12592C55.228 7.98255 55.1029 7.85249 54.9692 7.73597C54.1137 6.67714 52.8046 6 51.3373 6H4.67068C3.21384 6 1.91292 6.66756 1.05713 7.71348C0.91363 7.83569 0.77963 7.97326 0.657504 8.12591C0.143203 8.76879 -0.0637525 9.55835 0.0169137 10.3171C0.00836642 10.4325 0.00401673 10.5491 0.00401673 10.6667V45.3333C0.00401673 47.9107 2.09336 50 4.67069 50H51.3373C53.9147 50 56.004 47.9107 56.004 45.3333V10.6667C56.004 10.5341 55.9985 10.4029 55.9877 10.2731ZM50.004 16.2387L32.373 30.3436C29.8164 32.3888 26.1838 32.3888 23.6272 30.3436L6.00402 16.245V44H50.004V16.2387Z",
    fill: "#BFC4CD"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEmail);
export default __webpack_public_path__ + "static/media/icon-email.de79f45403fef83bdc830a007a689fcc.svg";
export { ForwardRef as ReactComponent };